import DateData, { pad2 } from './DateData';

const range = (first, end) => {
  if (end === undefined) {
    return range(0, first);
  }
  let start = first;
  const arr = new Array(Math.abs(end - first) + 1);
  const mapFunc = end > first ? () => start++ : () => start--;
  return Array.from(arr, mapFunc);
};

const degreeMenu = {
  '010': [25 /* 入学 */, 8 /* 最多8年 */, 3],
  '020': [22, 5, 3],
  '030': [22, 5, 3],
  '040': [18, 8, 4],
  '050': [18, 5, 3],
  '060': [15, 5, 3],
  '080': [15, 6, 3],
  '090': [12, 6, 3],
};

export function getEduDateMenu(degree) {
  return degreeMenu[degree] || [0, 0, 0];
}
/**
   * 不同学历下教育经历时间年的可选范围
   * @degree 学历code
   * @return {number} 学历最*大时间跨度
   */
export function getEduDateLimit(degree) {
  return (degreeMenu[degree] || [0, 0, 0])[1];
}

/**
   * 不同学历下教育经历时间年的跨度
   * @degree 学历code
   * @return {number} 正常学历年数
   */
export function getDegreeDate(degree) {
  return (degreeMenu[degree] || [0, 0, 0])[2];
}

/**
   * 教育经历开始年与出生年跨度
   * @degree 学历code
   * @return {number} 入学年龄
   */
export function getEduDefaultStartYear(degree) {
  return (degreeMenu[degree] || [0, 0, 0])[0];
}

/**
 * 教育经历结束年与出生年跨度
 * @degree 学历code
 * @return {number} 毕业年龄
 */
export function getEduDefaultEndYear(degree) {
  const [age, , years] = (degreeMenu[degree] || [0, 0, 0]);
  return age + years;
}
/**
* 对目标日期对象进行格式化
* @name Date.format
* @function
* @grammar Date.format(source, pattern)
* @param {Date} source 目标日期对象
* @param {string} pattern 日期格式化规则
* @remark
* 格式表达式，变量含义：
* hh: 带 0 补齐的两位 12 进制时表示
* h: 不带 0 补齐的 12 进制时表示
* HH: 带 0 补齐的两位 24 进制时表示
* H: 不带 0 补齐的 24 进制时表示
* mm: 带 0 补齐两位分表示
* m: 不带 0 补齐分表示
* ss: 带 0 补齐两位秒表示
* s: 不带 0 补齐秒表示
* yyyy: 带 0 补齐的四位年表示
* yy: 带 0 补齐的两位年表示
* MM: 带 0 补齐的两位月表示
* M: 不带 0 补齐的月表示
* dd: 带 0 补齐的两位日表示
* d: 不带 0 补齐的日表示
*
* @return {string} 格式化后的字符串
*/
export function format(date = new Date(), pattern = 'yyyy-MM-dd') {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minute = date.getMinutes();
  const seconds = date.getSeconds();
  return pattern
    .replace('yyyy', year)
    .replace('MM', pad2(month))
    .replace('M', month)
    .replace('dd', pad2(day))
    .replace('d', day)
    .replace('HH', pad2(hours))
    .replace('H', hours)
    .replace('mm', pad2(minute))
    .replace('m', minute)
    .replace('ss', pad2(seconds))
    .replace('s', seconds)
    .replace('S', date.getMilliseconds());
}
const dayCounts = {};
function getDays(count) {
  if (!dayCounts[count]) {
    dayCounts[count] = range(1, count);
  }
  return dayCounts[count];
}

function leapYear(year) {
  return year % 100 === 0 ? year % 400 === 0 : year % 4 === 0;
}

export function monthDays(month, year = (new Date()).getFullYear()) {
  switch (month) {
    case 1:
    case 3:
    case 5:
    case 7:
    case 8:
    case 10:
    case 12:
      return getDays(31);
    case 2:
      return getDays(year && leapYear(year) ? 29 : 28);
    default: // 4, 6, 9, 11 & other
      return getDays(30);
  }
}

export function getEffectiveDate(date, start, end) {
  const [year, month, day] = date;
  const newVal = [];
  let newYear = year;
  let newMonth = month;
  let newDay = day;
  // 只以年份判断是否至今
  if (year === 9999) {
    year && newVal.push(9999);
    month && newVal.push(99);
    day && newVal.push(99);
    return newVal;
  }
  if (year) {
    newYear = Math.max(Math.min(year, end.year), start.year);
  }
  if (month) {
    const maxMonth = newYear === end.year ? end.month : 12;
    const minMonth = newYear === start.year ? start.month : 1;
    newMonth = Math.max(Math.min(month, maxMonth), minMonth);
  }
  if (day) {
    const days = monthDays(newMonth, newYear);
    const maxDay = newYear === end.year && newMonth === end.month ? end.day : days[days.length - 1];
    const minDay = newYear === start.year && newMonth === start.month ? start.day : days[0];
    newDay = Math.max(Math.min(day, maxDay), minDay);
  }
  return [newYear, newMonth, newDay];
}

const dateUtil = (date, formatPattern) => new DateData(date, formatPattern);
dateUtil.getEduDateMenu = getEduDateMenu;
dateUtil.getEduDateLimit = getEduDateLimit;
dateUtil.getDegreeDate = getDegreeDate;
dateUtil.getEduDefaultStartYear = getEduDefaultStartYear;
dateUtil.getEduDefaultEndYear = getEduDefaultEndYear;
dateUtil.format = format;
dateUtil.monthDays = monthDays;
dateUtil.getEffectiveDate = getEffectiveDate;

export default dateUtil;
